<template v-if="active">
    <div>        
        <p class="card-style mt-3">
            <strong>
                {{ valueCard.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}
            </strong></p>

        <table class="table table-sm table-borderless">
            <tr
                v-for="(installments, index) in installments"
                :key="index"
            >
                <th scope="col" class="parcelas">{{index +1}}x de {{installmentsValue.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}} </th>
            </tr>
            
        </table>
    </div>
</template>
<script>
export default {
    name: 'TablePrice',
        props: {
        valueCard: {
            type: Number,
            default: 0,
        },
        installments: {
            type: Number,
            default: 0,
        },
        installmentsValue: {
            type: Number,
            default: 0,
        },
    },
    
}
</script>
<style scoped>

.card-style {
    text-align: center;
    padding: 10px;
    text-transform: uppercase;
    font-size: 25px;
    color: black;
}
.parcelas{
    color: black;
    text-align: center;
    /* margin-top: -30px; */
}
</style>